const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/patients.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/patients')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type FormPayload = {
  name: string;
  speciesKey: SpeciesKey;
  breedKey: string;
  lastVisit: string;
  nextVaccine: string;
  petDid: string;
  microchip: string;
  ownerEmail: string;
  ownerName: string;
  ownerPhone: string;
};